if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        if (!this.hasAttribute('open') && window.matchMedia('(max-width: 749px)').matches) return;
        if (!this.mobileScrollState) {
          super.hide();
          return;
        }

        const scrollState = this.mobileScrollState;
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus();
        if (this.openedBy?.isConnected) this.openedBy.focus({ preventScroll: true });
        window.pauseAllMedia();
        scrollState.ancestors.forEach(({ element, left, top }) => {
          if (element.isConnected) element.scrollTo({ left, top, behavior: 'instant' });
        });
        window.scrollTo({ left: scrollState.x, top: scrollState.y, behavior: 'instant' });
        this.mobileScrollState = null;
      }

      show(opener) {
        this.mobileScrollState = null;
        if (window.matchMedia('(max-width: 749px)').matches) {
          const ancestors = [];
          for (let element = opener.parentElement; element; element = element.parentElement) {
            ancestors.push({ element, left: element.scrollLeft, top: element.scrollTop });
          }
          this.mobileScrollState = { x: window.scrollX, y: window.scrollY, ancestors };
        }
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const container = this.querySelector('[role="document"]');
        if (window.matchMedia('(max-width: 749px)').matches) {
          container.scrollTo({ left: 0, top: 0, behavior: 'instant' });
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

